import styled from 'styled-components'

import { mq, sizes } from '../../../theme'

export const NumberPicker = styled.fieldset`
  display: flex;
  align-items: center;
  border: none;
  padding: 0;
  margin: 0;
`

export const Text = styled.div`
  ${({ theme }) => theme.textStyles.text_bold_16};
  padding: 0 1rem;
  min-width: 15rem;
  text-align: center;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_22};
    min-width: 20rem;
  }
`

export const Button = styled.button`
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.greenApple};
  color: transparent;
  position: relative;
  cursor: pointer;
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &::before,
  &::after {
    content: '';
    width: 1.7rem;
    height: 2px;
    background: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    backface-visibility: hidden;
  }
  &.-plus::after {
    opacity: 1;
    transform: translate(-50%, -50%) rotate(90deg);
  }
`
